import React from "react";

export const FemPageNavBar = () => {
  return (
    <div>
      <div className="fem-navbar max-width">
        <div className="fem-navbar-container mw-ct">
          <div className="fem-navbar-container-left">
            <p>
              <a href="/">PRIMER EQUIPO</a>
            </p>
            <p>
              <a href="/">EQUIPO FEMENINO</a>
            </p>
            <p className="nav-psg-text">{"  "} PSG TV</p>
          </div>
        </div>
      </div>
    </div>
  );
};
